<template>
  <div v-if="licence">
    <h2>Details</h2>

    <v-switch :input-value="showInactiveUsers" label="Inklusive inaktiven Nutzern"
              @change="showInactiveUsers = !showInactiveUsers"/>
    <br/>
    <v-data-table
        :headers="standardHeaders"
        :items="filteredUsers"
        :search="search"
        item-key="courseRunId"
        :items-per-page="15"
        class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
            append-icon="mdi-magnify"
            v-model="search"
            single-line
            label="Suche"
            class="mx-4"
        />
      </template>

      <template v-slot:item.add_licence="{ item }">
        <v-btn
            v-if="item.isOpen"
            @click="addLicence(item)"
            class="ma-2"
            outlined
            x-small
            fab
            color="indigo"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.remove_licence="{ item }">
        <v-btn
            v-if="item.isPlanned"
            @click="removeLicence(item)"
            class="ma-2"
            outlined
            x-small
            fab
            color="indigo"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.startDate="{item}">
        {{ item.startDate | moment("DD.MM.YYYY HH:mm") }}
      </template>
      <template v-slot:item.endDate="{item}">
        <v-chip
            :color="getEndDateColor(item)"
            dark
        >
          {{ item.endDate | moment("DD.MM.YYYY HH:mm") }}
        </v-chip>

      </template>
      <template v-slot:item.assignmentDate="{item}">
        {{ item.assignmentDate | moment("DD.MM.YYYY HH:mm") }}
      </template>
      <template v-slot:item.certificate="{ item }">
        <v-btn v-if="item.certificateLink"
               @click="downloadCertificate(item)"
               class="ma-2"
               outlined
               x-small
               fab
               color="indigo"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.restart="{ item }">
        <v-btn v-if="item.canRestart"
               @click="reAddLicence(item)"
               class="ma-2"
               outlined
               x-small
               fab
               color="indigo"
        >
          <v-icon>mdi-restart</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.reset="{ item }">
        <v-btn v-if="item.canReset"
               @click="restartLicence(item)"
               class="ma-2"
               outlined
               x-small
               fab
               color="indigo"
        >
          <v-icon>mdi-restart</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.finish="{ item }">
        <v-btn v-if="item.canReset"
               @click="finishLicence(item)"
               class="ma-2"
               outlined
               x-small
               fab
               color="indigo"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.progress="{item}">
        {{ item.progress }}
      </template>
      <template v-slot:item.upload="{item}">
        <input v-if="item.certificateLink" type="file" @change="(event) => {uploadFile(event, item)}" ref="file">
      </template>
    </v-data-table>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>
  </div>
</template>

<script>
import License from "@/models/License";

export default {
  name: "LicenceDetailItem",
  props: {
    licence: {
      type: License,
      default: null
    },
    superAdmin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getEndDateColor(item) {
      if (item.isFailed) {
        return 'red';
      } else if (item.isSuccess) {
        console.log(item);
        return 'green';
      } else {
        return 'white';
      }
    },
    addLicence(licenceUser) {
      this.loading = true;
      this.$httpCourseRunApi.assign(this.superAdmin ? this.licence.companyId : null, this.licence.course.id, [licenceUser.id],
          () => {
            this.loading = false;
            this.successText = "Kurs zugewiesen";
            this.success = true;
            setTimeout(() => this.success = false, 3000);
            this.$emit("reload")
          }, (error) => {
            this.loading = false;
            console.error(error);
            this.errorText = "Sie verfügen über keine freien Lizenzen";
            this.error = true;
            setTimeout(() => this.error = false, 5000);
          })
    },
    reAddLicence(licenceUser) {
      this.loading = true;
      this.$httpCourseRunApi.reassign(this.superAdmin ? this.licence.companyId : null, this.licence.course.id, [licenceUser.id],
          () => {
            this.loading = false;
            this.successText = "Kurs erneut zugewiesen";
            this.success = true;
            setTimeout(() => this.success = false, 3000);
            this.$emit("reload")
          }, (error) => {
            this.loading = false;
            this.errorText = "Fehler: " + error;
            this.error = true;
            setTimeout(() => this.error = false, 5000);
          })
    },
    removeLicence(licenceUser) {
      this.loading = true;
      this.$httpCourseRunApi.remove(this.superAdmin ? this.licence.companyId : null, this.licence.course.id, [licenceUser.id],
          () => {
            this.loading = false;
            this.successText = "Kurs entfernt";
            this.success = true;
            setTimeout(() => this.success = false, 3000);
            this.$emit("reload")
          }, (error) => {
            this.loading = false;
            this.errorText = "Fehler: " + error;
            this.error = true;
            setTimeout(() => this.error = false, 5000);
          })
    },
    restartLicence(user) {
      this.loading = true;
      this.$httpUserApi.resetCourseProgress(user.id, user.courseRunId, () => {
        this.loading = false;
        this.successText = "Fortschritt zurückgesetzt";
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.$emit("reload")
      }, (error) => {
        this.loading = false;
        this.errorText = "Fehler: " + error;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    finishLicence(user) {
      this.loading = true;
      this.$httpUserApi.finishCourseProgress(user.id, user.courseRunId, () => {
        this.loading = false;
        this.successText = "Kurs beendet.";
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.$emit("reload")
      }, (error) => {
        this.loading = false;
        this.errorText = "Fehler: " + error;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    downloadCertificate(licenceUser) {
      this.$httpDownloadApi.download(licenceUser.certificateLink, "Zertifikat");
    },

    uploadFile(event,licenceUser ) {
      this.$httpLicenseApi.upload(event.target.files[0], licenceUser.courseRunId, () => {
        this.successText = "Hochgeladen.";
        this.success = true;
        setTimeout(() => this.success = false, 3000);
      }, (error) => {
        this.errorText = "Fehler: " + error;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
  },
  computed: {
    filteredUsers() {
      return this.licence.licenceUsers.filter(licenceUser => this.showInactiveUsers || licenceUser.isActive)
    },
    standardHeaders() {
      let headers = [
        {text: "Vorname", value: "name"},
        {text: "Nachname", value: "surname"},
        {text: "Username", value: "username"},
        {text: "Department", value: "departments"},
        {text: "Lizenz zuteilen", value: "add_licence", sortable: false},
        {text: "Lizenz entziehen", value: "remove_licence", sortable: false},
        {text: "Datum Zuteilung", value: "assignmentDate"},
        {text: "Datum Schulungsbeginn", value: "startDate"},
        {text: "Datum Schulungsabschluss", value: "endDate"},
        {text: "Zertifikat", value: "certificate", sortable: false},
        {text: "Schulung erneut zuteilen", value: "restart", sortable: false}
      ]
      if (this.superAdmin) {
        headers.push({
          text: "Fortschritt zurücksetzen", value: "reset", sortable: false
        })
        headers.push({
          text: "Auf Fertig setzen", value: "finish", sortable: false
        })
        headers.push({
          text: "Fortschritt", value: "progress", sortable: false
        })
        headers.push({
          text: "ZertifikatsUpload", value: "upload", sortable: false
        })
        return headers;
      } else {
        return headers;
      }
    }
  },
  data: () => ({
    showInactiveUsers: false,
    search: '',
    errorText: "",
    successText: "",
    loading: false,
    error: false,
    success: false
  }),
}
</script>

<style scoped>

</style>
